import { useGetPaginatedSubjectDidsQuery } from "@/src/graphql/generated/api/graphql";

export function usePaginatedSubjectDids(
    page: number = 0,
    pageSize: number = 15,
    skip: boolean = false
) {
    {
        const { data, loading, error } = useGetPaginatedSubjectDidsQuery({
            variables: {
                paginationInput: {
                    page,
                    pageSize,
                },
                filters: [],
                sorting: [],
            },
            skip,
        });

        const subjectDids = data?.getPaginatedSubjectDids.rows || [];
        const count = data?.getPaginatedSubjectDids.pagination.totalCount || 0;

        return {
            loading,
            error,
            subjectDids,
            count,
        };
    }
}
